export function convertirUSD(tasa, vef) {
  return (vef / tasa).toFixed(2);
}

export function convertirVEF(tasa, usd) {
  return (usd * tasa).toFixed(2);
}
